export interface Video { id: string; title: string; duration: number; url: string; }; export interface Playlist { id: string; title: string; uploader: string; tags: string[]; videos: Video[]; }; export const videoPlaylists: Playlist[] = [{ id: 'PLDyJYA6aTY1lPWXBPk0gw6gR8fEtPDGKa', title: 'Уроки Python для начинающих / Программирование на Питон с нуля', uploader: 'Школа itProger / Программирование', tags: ['Python', 'Начинающие', 'Основы'], videos: [
  {
    "id": "34Rp6KVGIEM",
    "title": "Уроки Python с нуля / #1 – Программирование на Питон для начинающих",
    "duration": 329,
    "url": "https://www.youtube.com/watch?v=34Rp6KVGIEM"
  },
  {
    "id": "CfqX2_xY8VQ",
    "title": "Уроки Python с нуля / #2 – Установка среды разработки",
    "duration": 666,
    "url": "https://www.youtube.com/watch?v=CfqX2_xY8VQ"
  },
  {
    "id": "ML5tP8m6SHw",
    "title": "Уроки Python с нуля / #3 – Базовые операции в языке Python",
    "duration": 1174,
    "url": "https://www.youtube.com/watch?v=ML5tP8m6SHw"
  },
  {
    "id": "DZvNZ9l9NT4",
    "title": "Уроки Python с нуля / #4 – Переменные и типы данных",
    "duration": 1312,
    "url": "https://www.youtube.com/watch?v=DZvNZ9l9NT4"
  },
  {
    "id": "SUDNfS_0X-Q",
    "title": "Уроки Python с нуля / #5 – Условные операторы",
    "duration": 1391,
    "url": "https://www.youtube.com/watch?v=SUDNfS_0X-Q"
  },
  {
    "id": "vMD6-jzgDvI",
    "title": "Уроки Python с нуля / #6 – Циклы и операторы в них (for, while)",
    "duration": 949,
    "url": "https://www.youtube.com/watch?v=vMD6-jzgDvI"
  },
  {
    "id": "-X2ubBdP2Ak",
    "title": "Уроки Python с нуля / #7 – Списки (list). Функции и их методы",
    "duration": 1603,
    "url": "https://www.youtube.com/watch?v=-X2ubBdP2Ak"
  },
  {
    "id": "pqaBWcsBGyA",
    "title": "Уроки Python с нуля / #8 – Функции строк. Индексы и срезы",
    "duration": 1360,
    "url": "https://www.youtube.com/watch?v=pqaBWcsBGyA"
  },
  {
    "id": "cQfu-hYo2o4",
    "title": "Уроки Python с нуля / #9 – Кортежи (tuple)",
    "duration": 631,
    "url": "https://www.youtube.com/watch?v=cQfu-hYo2o4"
  },
  {
    "id": "W2oO1Y-QDzo",
    "title": "Уроки Python с нуля / #10 – Словари (dict) и работа с ними",
    "duration": 970,
    "url": "https://www.youtube.com/watch?v=W2oO1Y-QDzo"
  },
  {
    "id": "6eNtZ8wY7qI",
    "title": "Уроки Python с нуля / #11 – Множества (set и frozenset)",
    "duration": 490,
    "url": "https://www.youtube.com/watch?v=6eNtZ8wY7qI"
  },
  {
    "id": "6K5v4--G__U",
    "title": "Уроки Python с нуля / #12 – Функции (def, lambda)",
    "duration": 1341,
    "url": "https://www.youtube.com/watch?v=6K5v4--G__U"
  },
  {
    "id": "t-xQAhLNYSs",
    "title": "Уроки Python с нуля / #13 – Работа с файлами за счет Питон",
    "duration": 797,
    "url": "https://www.youtube.com/watch?v=t-xQAhLNYSs"
  },
  {
    "id": "3nveLco08Y0",
    "title": "Уроки Python с нуля / #14 – Обработчик исключений. Конструкция «try - except»",
    "duration": 632,
    "url": "https://www.youtube.com/watch?v=3nveLco08Y0"
  },
  {
    "id": "uGsSTZjUoIc",
    "title": "Уроки Python с нуля / #15 – Менеджер «With ... as» для работы с файлами",
    "duration": 380,
    "url": "https://www.youtube.com/watch?v=uGsSTZjUoIc"
  },
  {
    "id": "dNg3l-wpRdY",
    "title": "Уроки Python с нуля / #16 – Модули в языке Питон. Создание и работа с модулями",
    "duration": 1265,
    "url": "https://www.youtube.com/watch?v=dNg3l-wpRdY"
  },
  {
    "id": "gFRa6qVN980",
    "title": "Уроки Python с нуля / #17 – Основы ООП. Создание класса и объекта",
    "duration": 900,
    "url": "https://www.youtube.com/watch?v=gFRa6qVN980"
  },
  {
    "id": "Y6N-na2WOx8",
    "title": "Уроки Python с нуля / #18 – Конструкторы, переопределение методов",
    "duration": 534,
    "url": "https://www.youtube.com/watch?v=Y6N-na2WOx8"
  },
  {
    "id": "4N4GSzLF7JM",
    "title": "Уроки Python с нуля / #19 – Наследование, инкапсуляция, полиморфизм",
    "duration": 1108,
    "url": "https://www.youtube.com/watch?v=4N4GSzLF7JM"
  },
  {
    "id": "tuFuDKE7DF8",
    "title": "Уроки Python с нуля / #20 – Декораторы функций",
    "duration": 481,
    "url": "https://www.youtube.com/watch?v=tuFuDKE7DF8"
  },
  {
    "id": "-viVz4cwDU4",
    "title": "Уроки Python с нуля / #21 – Заключительная часть",
    "duration": 120,
    "url": "https://www.youtube.com/watch?v=-viVz4cwDU4"
  },
  {
    "id": "6HFHCO2PtKM",
    "title": "Профессия «Python разработчик» | Презентация онлайн курса",
    "duration": 312,
    "url": "https://www.youtube.com/watch?v=6HFHCO2PtKM"
  }
]}];